// extracted by mini-css-extract-plugin
export default {"wrapper":"O6oWxK","image":"nJpW4P","container":"pQplUJ"};